import { render, staticRenderFns } from "./dropzone.vue?vue&type=template&id=ed4f439a"
import script from "./dropzone.js?vue&type=script&lang=js&external"
export * from "./dropzone.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports